import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

const TextThankYou = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TextThankYou">
      {S.space}
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section4Description1Part2')}
        <p>
          <span role="img" aria-labelledby="lamp">
            💡{S.space}
          </span>
          {t('clientConnect.section4Description2Part1')}
          {S.space}
          <span role="img" aria-labelledby="lamp">
            💡
          </span>
          {S.space}
          {t('clientConnect.section4Description2Part2')}
          <a
            href="https://help.getslick.com/en/articles/6354664-how-to-find-your-google-review-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('clientConnect.googleLink')}
          </a>
          {t('clientConnect.section4Description2Part3')} <span className="break-line" />
          {t('clientConnect.section4Description2Part4')}
          <a
            href="https://help.getslick.com/en/articles/6362168-how-to-find-your-facebook-review-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('clientConnect.facebookLink')}
          </a>
        </p>
      </div>
    </div>
  );
};

export default TextThankYou;
